export interface IMockData {
  id: string;
  value: string;
}

export const mockData = [
  { id: "1", value: "11,247" },
  { id: "2", value: "2,698" },
  { id: "3", value: "1,234" },
  { id: "4", value: "8,921" },
  { id: "5", value: "2,013" },
];
